import React, { useCallback, useContext, useState } from 'react';

import usePopup from '../../hooks/usePopup';
import useIsViewerRole from '../../hooks/useIsViewerRole';
import AnalyticsContext from '../../contexts/AnalyticsContext';
import AccountContext from '../../contexts/AccountContext';
import ContextMenuContext from '../../kingpin/atoms/ContextMenu/ContextMenuContext';
import InlineDialog from '../InlineDialog';
import { Option } from '../../kingpin/atoms/ContextMenu';
import { ContextMenuDiv } from '../../kingpin/atoms/ContextMenu/styles';
import { ModalTransition } from '@atlaskit/modal-dialog';
import ContactUsFormContainer from '../ContactUsForm';
import NavItem from '../../kingpin/navigation/NavItem';

const HelpCenterButton = () => {
  const { isOpen, open, close } = usePopup();
  const [contactUsIsOpen, setContactUsIsOpen] = useState<boolean>(false);
  const { trackEvent } = useContext(AnalyticsContext);
  const { blockBasicUsersContactingSupport } = useContext(AccountContext);
  const isViewerRole = useIsViewerRole();

  const showContactSupport = !blockBasicUsersContactingSupport || !isViewerRole;

  const onHelpClicked = useCallback(() => {
    window.open('https://help.fleetops.com/', '_blank');
    trackEvent('Help - Contact Form Opened');
    close();
  }, [close, trackEvent]);

  const onContactSupportClicked = useCallback(() => {
    setContactUsIsOpen(true);
    close();
  }, [close]);

  return (
    <div style={{ height: 34, display: 'flex', justifyContent: 'center' }}>
      <ContextMenuContext.Provider
        value={{
          closeMenu: close,
          hideMenu: close,
        }}
      >
        <InlineDialog
          content={
            <ContextMenuDiv>
              <Option
                icon="open-link"
                label={'Help Center'}
                onClick={onHelpClicked}
              />
              {showContactSupport && (
                <Option
                  icon="mail"
                  label="Contact Support"
                  onClick={onContactSupportClicked}
                />
              )}
            </ContextMenuDiv>
          }
          placement={'top-start'}
          isOpen={isOpen}
          onClose={close}
        >
          <NavItem
            iconColor={'var(--color-icon-secondary)'}
            isActiveOverride={false}
            to={'#'}
            onClick={isOpen ? close : open}
            icon={'help'}
            testId={'support-button'}
          />
        </InlineDialog>
      </ContextMenuContext.Provider>
      <ModalTransition>
        {contactUsIsOpen && (
          <ContactUsFormContainer close={() => setContactUsIsOpen(false)} />
        )}
      </ModalTransition>
    </div>
  );
};

export default HelpCenterButton;
